import * as React from 'react';
import { EGDSSpacing } from '@egds/react-core/spacing';
export var FooterTextSection = function (_a) {
  var _b;
  var section = _a.section;
  if (!((_b = section === null || section === void 0 ? void 0 : section.sectionData) === null || _b === void 0 ? void 0 : _b.length)) {
    return null;
  }
  return React.createElement("ul", {
    className: "footer-legal-text no-bullet"
  }, section.sectionData.map(function (item) {
    if (item && item.text && item.type === 'text') {
      return React.createElement(EGDSSpacing, {
        padding: {
          blockstart: 'two'
        },
        key: item.id
      }, React.createElement("li", null, React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: item.text
        }
      })));
    }
    return null;
  }));
};